import { BLUE_GREY_200, LILAC_100, LILAC_200, LILAC_300, LILAC_400, WHITE, checkIsPlatform, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTableStyles = (props, theme) => {
  var _props$checkboxPositi = props.checkboxPosition,
    checkboxPosition = _props$checkboxPositi === void 0 ? 'top' : _props$checkboxPositi,
    _props$radioPosition = props.radioPosition,
    radioPosition = _props$radioPosition === void 0 ? 'top' : _props$radioPosition,
    style = props.style;
  var checkboxPositionCenter = checkboxPosition === 'center';
  var radioPositionCenter = radioPosition === 'center';
  return StyleSheet.create({
    container: {
      borderWidth: 1,
      borderColor: theme == 'white' ? BLUE_GREY_200 : LILAC_400,
      backgroundColor: theme == 'white' ? WHITE : LILAC_100,
      flex: 1
    },
    tableHeaderContainer: {
      flexDirection: 'row',
      flexShrink: 0,
      zIndex: 9
    },
    tableScrollContainer: {
      flex: 1,
      display: style && checkIsPlatform('web') ? 'table' : 'flex'
    },
    tableCellContainer: {
      flexDirection: 'row',
      flexShrink: 0,
      zIndex: -10000
    },
    bottomBorder: {
      borderWidth: 0,
      borderBottomWidth: 1,
      borderBottomColor: theme == 'white' ? BLUE_GREY_200 : LILAC_400
    },
    rightBorder: {
      borderWidth: 0,
      borderRightWidth: 1,
      borderRightColor: theme == 'white' ? BLUE_GREY_200 : LILAC_400
    },
    hoverState: {
      backgroundColor: LILAC_200
    },
    noDataContainer: {
      paddingHorizontal: tokens.spacing.SPACING_8,
      paddingVertical: tokens.spacing.SPACING_16,
      alignItems: 'center'
    },
    checkboxContainer: {
      backgroundColor: LILAC_300,
      padding: tokens.spacing.SPACING_16,
      alignItems: 'center',
      justifyContent: 'center'
    },
    cellCheckbox: Object.assign({
      padding: tokens.spacing.SPACING_16
    }, checkboxPositionCenter && {
      justifyContent: 'center'
    }),
    radioContainer: {
      backgroundColor: LILAC_300,
      padding: tokens.spacing.SPACING_16,
      alignItems: 'center',
      justifyContent: 'center'
    },
    cellRadio: Object.assign({
      padding: tokens.spacing.SPACING_16
    }, radioPositionCenter && {
      justifyContent: 'center'
    })
  });
};